// ============================================================
// VCE — Registry de TIPOS de contenido
// ============================================================
// Añadir un tipo = añadir una entrada. El motor nunca se toca. (P5/P7)
// `fallback` = política ante tipo desconocido: el motor NUNCA crashea.
// ============================================================
import type { MediaTypeDef } from '../types';

const VIDEO_RE = /\.(mp4|mov|webm)$/i;

export const MEDIA_TYPES: Record<string, MediaTypeDef> = {
  image: {
    key: 'image',
    detect: (url: string) => !VIDEO_RE.test(url),
    fallback: 'placeholder',
  },
  video: {
    key: 'video',
    detect: (url: string) => VIDEO_RE.test(url),
    fallback: 'placeholder',
  },
};

export const isVideoUrl = (url: string): boolean => MEDIA_TYPES.video.detect(url);
